export default __webpack_public_path__ + "static/media/g-mol.6fa772a1.svg";